import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';
import ImageButtonList from '../common/imageButtonList';

class MessagesList extends Component {
  handleItemSelection = (id) => {
    this.props.history.push(`/messages/popup`);
  };

  state = {
    textImage: require('./images/1361_elements.png'),
    popUpImage: require('./images/1361_Message_popup.png'),
    navigationBar: {
      back: true,
      backRoute: '/main_menu',
      mainMenu: true,
      navigate: true,
    },
    messagesUnread: [
      // {
      //   id: "message1",
      //   highlight: require("./images/1361_Message1_unread_HL.png"),
      //   unhighlight: require("./images/1361_Message1_unread_UH.png"),
      //   handleSelect: this.handleItemSelection,
      //   checked: false,
      // },
      {
        id: 'message3',
        highlight: require('./images/1361_MessageEducation_unread_HL.png'),
        unhighlight: require('./images/1361_MessageEducation_unread_UH.png'),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: 'message2',
        highlight: require('./images/1361_TellUsAbout_unread_HL.png'),
        unhighlight: require('./images/1361_TellUsAbout_unread_UH.png'),
        // dont do anything for selecting bottom messages
        // handleSelect: this.handleItemSelection,
        checked: false,
      },
    ],
    messagesRead: [
      // {
      //   id: "message1",
      //   highlight: require("./images/1361_Message1_read_HL.png"),
      //   unhighlight: require("./images/1361_Message1_read_UH.png"),
      //   handleSelect: this.handleItemSelection,
      //   checked: false,
      // },
      {
        id: 'message3',
        highlight: require('./images/1361_MessageEducation_read_HL.png'),
        unhighlight: require('./images/1361_MessageEducation_read_UH.png'),
        handleSelect: this.handleItemSelection,
        checked: false,
      },
      {
        id: 'message2',
        highlight: require('./images/1361_TellUsAbout_unread_HL.png'),
        unhighlight: require('./images/1361_TellUsAbout_unread_UH.png'),
        // handleSelect: this.handleItemSelection,
        checked: false,
      },
    ],
  };

  componentWillMount() {
    document.addEventListener('keyup', this.handleKeyup, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleKeyup);
  }

  render() {
    let messages = null;
    switch (this.props.match.params.status) {
      case 'unread':
        messages = this.state.messagesUnread;
        break;
      case 'read':
        messages = this.state.messagesRead;
        break;
      default:
        messages = this.state.messagesUnread;
    }
    return (
      <div className="messages-list">
        <ImageText id="text" src={this.state.textImage} />
        <ImageButtonList imageButtons={messages} flexClass="flex-vertical" />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnecteMessagesList = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(MessagesList);

export default withRouter(ConnecteMessagesList);
